import { useState, useEffect, useRef } from "react"

const useScrollPosition = () => {
    const [scrollPosition, setScrollPosition] = useState(0)
    const rafRef = useRef<number | null>(null)

    useEffect(() => {
        const handleScroll = () => {
            if (rafRef.current !== null) return
            rafRef.current = requestAnimationFrame(() => {
                setScrollPosition(window.scrollY)
                rafRef.current = null
            })
        }

        window.addEventListener("scroll", handleScroll, { passive: true })
        return () => {
            window.removeEventListener("scroll", handleScroll)
            if (rafRef.current !== null) {
                cancelAnimationFrame(rafRef.current)
            }
        }
    }, [])

    return scrollPosition
}

export default useScrollPosition
